import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import { NavLink } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import moment from "moment";
import FeeSystemMenu from "./FeeSystemMenu";
import { Form } from "react-bootstrap";

function AdvanceReports() {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));

  const [reportType, setReportType] = useState("collection");
  const [StartDate, setStartDate] = useState("");
  const [EndDate, setEndDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [validated, setValidated] = useState(false);

  const [collectionData, setCollectionData] = useState([]);
  const [outstandingData, setOutstandingData] = useState([]);

  useEffect(() => {
    document.title = "Advance Reports";
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }
    setValidated(true);
    setLoading(true);
    setCollectionData([]);
    setOutstandingData([]);

    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      StartDate: StartDate,
      EndDate: EndDate,
    };

    const endpoint =
      reportType === "collection"
        ? "ADLedger/GetAdvanceCollectionReport"
        : "ADLedger/GetAdvanceOutstandingReport";

    axios({
      method: "post",
      url: config.base_url + endpoint,
      headers: { "Content-Type": "application/json" },
      data: data,
    })
      .then(function (response) {
        if (response.data.status_code === 1) {
          if (reportType === "collection") {
            setCollectionData(response.data.ListofRecords || []);
          } else {
            setOutstandingData(response.data.ListofRecords || []);
          }
        } else {
          toast.error(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        setLoading(false);
      })
      .catch(function () {
        toast.error("Network Error..", {
          position: toast.POSITION.TOP_RIGHT,
        });
        setLoading(false);
      });
  };

  const collectionTotal = collectionData.reduce(
    (sum, item) => sum + (item.AdvanceAmount || 0),
    0
  );

  const outstandingTotal = outstandingData.reduce(
    (sum, item) => sum + (item.RemainingAdvance || 0),
    0
  );

  return (
    <>
      <FeeSystemMenu />
      <ToastContainer />
      <div className="container body-content">
        <div className="page-head">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <NavLink to="/Dashboard">Dashboard</NavLink>
                    </li>
                    <li className="breadcrumb-item">
                      <NavLink to="/FeeSystem/FeeSystemDashboard">
                        Fee System
                      </NavLink>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Advance Reports
                    </li>
                  </ol>
                </nav>
                <div className="page-title">Advance Reports</div>
              </div>
            </div>
          </div>
        </div>

        <div className="page-content">
          <div className="container">
            <div className="card">
              <div className="card-body card-form-wrap">
                <Form
                  noValidate
                  validated={validated}
                  onSubmit={handleSubmit}
                >
                  <div className="row align-items-end mb-3">
                    <div className="col-md-3">
                      <label className="col-form-label col-form-label-sm">
                        Report Type:
                      </label>
                      <select
                        className="form-select"
                        value={reportType}
                        onChange={(e) => setReportType(e.target.value)}
                      >
                        <option value="collection">
                          Advance Collection Report
                        </option>
                        <option value="outstanding">
                          Advance Outstanding Report
                        </option>
                      </select>
                    </div>
                    <div className="col-md-2">
                      <label className="col-form-label col-form-label-sm">
                        Start Date:
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        value={StartDate}
                        onChange={(e) => setStartDate(e.target.value)}
                        required
                      />
                    </div>
                    <div className="col-md-2">
                      <label className="col-form-label col-form-label-sm">
                        End Date:
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        value={EndDate}
                        onChange={(e) => setEndDate(e.target.value)}
                        required
                      />
                    </div>
                    <div className="col-md-2">
                      <button
                        type="submit"
                        className="button button-primary w-100"
                        disabled={loading}
                      >
                        {loading ? (
                          <Spinner animation="border" size="sm" />
                        ) : (
                          "Generate Report"
                        )}
                      </button>
                    </div>
                  </div>
                </Form>

                {/* Collection Report Results */}
                {reportType === "collection" && collectionData.length > 0 && (
                  <div className="mt-3">
                    <h6>
                      Advance Collection Report ({StartDate} to {EndDate})
                    </h6>
                    <table className="table table-striped table-bordered table-sm">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Receipt No</th>
                          <th>Student ID</th>
                          <th>Reg No</th>
                          <th>Student Name</th>
                          <th>Father Name</th>
                          <th>Description</th>
                          <th>Received By</th>
                          <th>Date</th>
                          <th className="text-end">Amount</th>
                          <th className="text-end">Adjusted</th>
                          <th className="text-end">Remaining</th>
                        </tr>
                      </thead>
                      <tbody>
                        {collectionData.map((item, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item.ID}</td>
                            <td>{item.Student_ID}</td>
                            <td>{item.Registration_No}</td>
                            <td>{item.Student_Name}</td>
                            <td>{item.Father_Name}</td>
                            <td>{item.Description}</td>
                            <td>{item.ReceivedBy_Name}</td>
                            <td>
                              {moment(item.ReceivedDate).format("DD/MM/YYYY")}
                            </td>
                            <td className="text-end">{item.AdvanceAmount}</td>
                            <td className="text-end">{item.AdjustmentAmount}</td>
                            <td className="text-end">{item.RemainingAdvance}</td>
                          </tr>
                        ))}
                        <tr>
                          <td colSpan="9" className="text-end fw-bold">
                            Total:
                          </td>
                          <td className="text-end fw-bold">
                            Rs. {collectionTotal}
                          </td>
                          <td colSpan="2"></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                )}

                {/* Outstanding Report Results */}
                {reportType === "outstanding" && outstandingData.length > 0 && (
                  <div className="mt-3">
                    <h6>
                      Advance Outstanding Report (as of {EndDate})
                    </h6>
                    <table className="table table-striped table-bordered table-sm">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Advance ID</th>
                          <th>Student ID</th>
                          <th>Reg No</th>
                          <th>Student Name</th>
                          <th>Father Name</th>
                          <th>Description</th>
                          <th>Received By</th>
                          <th>Received Date</th>
                          <th className="text-end">Amount</th>
                          <th className="text-end">Adjusted</th>
                          <th className="text-end">Remaining</th>
                        </tr>
                      </thead>
                      <tbody>
                        {outstandingData.map((item, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item.ID}</td>
                            <td>{item.Student_ID}</td>
                            <td>{item.Registration_No}</td>
                            <td>{item.Student_Name}</td>
                            <td>{item.Father_Name}</td>
                            <td>{item.Description}</td>
                            <td>{item.ReceivedBy_Name}</td>
                            <td>
                              {moment(item.ReceivedDate).format("DD/MM/YYYY")}
                            </td>
                            <td className="text-end">{item.AdvanceAmount}</td>
                            <td className="text-end">
                              {item.AdjustmentAmount}
                            </td>
                            <td className="text-end fw-bold">
                              {item.RemainingAdvance}
                            </td>
                          </tr>
                        ))}
                        <tr>
                          <td colSpan="11" className="text-end fw-bold">
                            Total Outstanding:
                          </td>
                          <td className="text-end fw-bold">
                            Rs. {outstandingTotal}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                )}

                {!loading &&
                  collectionData.length === 0 &&
                  outstandingData.length === 0 &&
                  validated && (
                    <div className="mt-3 text-center text-muted">
                      <p>No records found for the selected criteria.</p>
                    </div>
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AdvanceReports;
